import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../api";

const VerifyPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading"
  );
  const [message, setMessage] = useState<string>("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Invalid verification link.");
      return;
    }
    api
      .get(`/auth/verify/${token}`)
      .then((res) => {
        setStatus("success");
        setMessage(res.data.msg);
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.response?.data?.msg || "Verification failed.");
      });
  }, [token]);

  if (status === "loading") return <p>Activating account…</p>;

  if (status === "success") {
    return (
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <p>{message}</p>
        <Link to="/login">Log in</Link>
      </div>
    );
  }

  // error
  return (
    <div style={{ textAlign: "center", marginTop: "2rem" }}>
      <p>{message}</p>
      <p>
        <Link to="/register">Register again</Link> or{" "}
        <Link to="/login">Log in</Link>
      </p>
    </div>
  );
};

export default VerifyPage;
